import {
  collection, addDoc, query, where,
  orderBy, limit, getDocs, serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";

const COL = "memoriaAgente";

export async function guardarInteraccion({ userId, clienteId, clienteNombre, tipo, accion, nota, dias }) {
  try {
    await addDoc(collection(db, COL), {
      userId,
      clienteId:     clienteId     || "",
      clienteNombre: clienteNombre || "",
      tipo:          tipo          || "seguimiento",
      accion:        accion        || "",
      nota:          nota          || "",
      diasSiguiente: dias          || 7,
      completadaEn:  serverTimestamp(),
    });
  } catch (e) {
    console.error("Error guardando memoria:", e);
  }
}

// Devuelve un mapa { clienteId: [ { tipo, nota, fecha, diasSiguiente }, ... ] }
export async function obtenerMemoria(userId) {
  try {
    const q = query(
      collection(db, COL),
      where("userId", "==", userId),
      orderBy("completadaEn", "desc"),
      limit(80),
    );
    const snap = await getDocs(q);
    const memoria = {};
    snap.docs.forEach(d => {
      const data = d.data();
      const cid  = data.clienteId;
      if (!cid) return;
      if (!memoria[cid]) memoria[cid] = [];
      if (memoria[cid].length < 4) {
        memoria[cid].push({
          tipo:          data.tipo,
          nota:          data.nota || "",
          fecha:         (() => { const dt = data.completadaEn?.toDate?.(); if (!dt) return ""; return `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,"0")}-${String(dt.getDate()).padStart(2,"0")}`; })(),
          diasSiguiente: data.diasSiguiente,
        });
      }
    });
    return memoria;
  } catch (e) {
    console.warn("Memoria no disponible aún:", e.message);
    return {};
  }
}

// Devuelve las últimas interacciones reales con UN cliente específico
export async function getMemoriaCliente(userId, clienteId) {
  if (!userId || !clienteId) return [];
  try {
    const q = query(
      collection(db, COL),
      where("userId",    "==", userId),
      where("clienteId", "==", clienteId),
      orderBy("completadaEn", "desc"),
      limit(10),
    );
    const snap = await getDocs(q);
    return snap.docs.map(d => {
      const data = d.data();
      const dt   = data.completadaEn?.toDate?.();
      const fecha = dt
        ? `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,"0")}-${String(dt.getDate()).padStart(2,"0")}`
        : "";
      return {
        fecha,
        tipo:   data.tipo   || "",
        nota:   data.nota   || "",
        accion: data.accion || "",
      };
    });
  } catch (e) {
    console.warn("No se pudo cargar memoria del cliente:", e.message);
    return [];
  }
}
